import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import TooltipProps from './TooltipProps'

import Animation from '../Common/Animation'
import Content from './Content'

export default {
    template: '<div><slot></slot></div>',
    props: TooltipProps,
    mixins: [
        KendoBaseComponent,
        Animation,
        Content
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoTooltip(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTooltip()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoTooltip/KendoTooltipMixin.js